import { Directive, Input, OnChanges, OnDestroy, SimpleChanges, TemplateRef, ViewContainerRef } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { AuthService } from "src/app/modules/auth/services/auth.service";
import { Role, UserModel } from "../interfaces/user";

@Directive({
  selector: '[appUserRole]',
})
export class UserRoleDirective implements OnChanges, OnDestroy {
  @Input() appUserRole!: Role[];
  @Input() disableIfUnauthorized: boolean = false;

  private currentUser!: UserModel;
  private destroy$ = new Subject<void>();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {
    this.authService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.currentUser = user;
        if (this.appUserRole) this.updateView();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["appUserRole"] || changes["disableIfUnauthorized"]) this.updateView();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateView(): void {
    if (!this.appUserRole || this.appUserRole.length === 0) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }

    const userRole = this.currentUser?.role;
    const hasAccess = userRole && this.appUserRole.includes(userRole);
    hasAccess ? this.viewContainer.createEmbeddedView(this.templateRef) : this.viewContainer.clear();
  }
}
